import React from "react";
import { Download, Paperclip } from "lucide-react";

function download(att) {
  // base64 -> blob -> click anchor
  const byteChars = atob(att.file_data || "");
  const bytes = new Uint8Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) bytes[i] = byteChars.charCodeAt(i);
  const blob = new Blob([bytes], { type: att.content_type || "application/octet-stream" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = att.filename || "attachment";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export default function AttachmentList({ items = [] }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="card p-5">
      <h2 className="font-semibold mb-3 flex items-center gap-2"><Paperclip size={16} /> Attachments ({items.length})</h2>
      <ul className="divide-y divide-gray-100">
        {items.map((a, i) => (
          <li key={i} className="py-2 flex items-center justify-between">
            <div>
              <div className="text-sm font-medium">{a.filename}</div>
              <div className="text-xs text-gray-500">{a.content_type} · {Math.round((a.file_size || 0) / 1024)} KB</div>
            </div>
            <button onClick={() => download(a)} className="btn-secondary flex items-center gap-1 text-xs">
              <Download size={14} /> Download
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
